import { axios } from "utils";

import { PUBLIC_DAIRY_URL as endpoint } from "consts";

import { DairyCowType, DairyFeedAdditive, DairyFeedType, DairyManureAdditive, DairyManureStorage } from "models";

export const getDairyCowTypes = async ({ enabled }: { enabled?: boolean } = {}): Promise<DairyCowType[]> =>
  axios.get(`${endpoint}/dairy-cow-types`, { params: { enabled } });

export const getDairyFeedAdditives = async (): Promise<DairyFeedAdditive[]> => axios.get(`${endpoint}/dairy-feed-additives`);

export const getDairyFeedTypes = async ({ enabled }: { enabled?: boolean } = {}): Promise<DairyFeedType[]> =>
  axios.get(`${endpoint}/dairy-feed-types`, { params: { enabled } });

export const getDairyManureStorage = async (): Promise<DairyManureStorage[]> => axios.get(`${endpoint}/dairy-manure-storage-types`);

export const getDairyManureAdditives = async (): Promise<DairyManureAdditive[]> => axios.get(`${endpoint}/dairy-manure-additives`);
